import CbMenuItem from './src/menu-item.vue';

CbMenuItem.install = function(Vue) {
  Vue.component(CbMenuItem.name, CbMenuItem);
};

export default CbMenuItem;
